import { render, staticRenderFns } from "./ObservationsPrintReportMapPage.vue?vue&type=template&id=74b4d594&"
import script from "./ObservationsPrintReportMapPage.vue?vue&type=script&lang=js&"
export * from "./ObservationsPrintReportMapPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports